import tw from "twin.macro";

export const Spacing12 = tw.div`h-12`;
export const Spacing32 = tw.div`h-32`;

export const Wrapper = tw.div`flex flex-wrap gap-x-8 gap-y-12`;
